import {
    StyledExtraTopicAmount,
    StyledHeaderButton,
    StyledHeaderTitle,
    StyledIntentSelectedTopicHeaderBlock,
    StyledIntentSelectedTopicView,
    StyledUpgradeBtn,
} from "./styles";
import IntentSelectedTopicTable from "../IntentSelectedTopicTable/IntentSelectedTopicTable";
import ApplyTopicView from "../ApplyTopicView/ApplyTopicView";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import { useSelector } from "react-redux";
import {
    selectIntentSelectedTopics,
    selectIsSelectedIntentTopicsOverLimit,
} from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import { translate } from "app/filters/i18nFilter";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { showIntentMoreTopicsHook } from "app/pages/sales-intelligence/sub-modules/intent/internalHooks/hooks";
import intentTrackingService from "app/pages/sales-intelligence/services/tracking/intent/trackingService";

const IntentSelectedTopicView = () => {
    const selectedTopics: readonly Topic[] = useSelector(selectIntentSelectedTopics);
    const hasExtraTopic = useSelector(selectIsSelectedIntentTopicsOverLimit);
    const numIntentTopics = salesSettingsHelper.getNumIntentTopics();

    const onUpgradeClick = () => {
        void intentTrackingService.trackUpgradeIntentAction();
        showIntentMoreTopicsHook();
    };

    return (
        <StyledIntentSelectedTopicView>
            <StyledIntentSelectedTopicHeaderBlock>
                <StyledHeaderTitle>
                    {translate("si.intent.management.selected-topics.title")} (
                    <StyledExtraTopicAmount hasExtraTopic={hasExtraTopic}>
                        {selectedTopics.length}
                    </StyledExtraTopicAmount>
                    /{numIntentTopics})
                </StyledHeaderTitle>
                <StyledHeaderButton>
                    <StyledUpgradeBtn
                        type="flat"
                        onClick={onUpgradeClick}
                    >
                        {translate("si.intent.management.btn.upgrade")}
                    </StyledUpgradeBtn>
                </StyledHeaderButton>
            </StyledIntentSelectedTopicHeaderBlock>
            <IntentSelectedTopicTable />
            <ApplyTopicView />
        </StyledIntentSelectedTopicView>
    );
};

export default IntentSelectedTopicView;
